import { render, staticRenderFns } from "./WPLocaleSwitcher.vue?vue&type=template&id=4b119a93"
import script from "./WPLocaleSwitcher.vue?vue&type=script&lang=ts"
export * from "./WPLocaleSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./WPLocaleSwitcher.vue?vue&type=style&index=0&id=4b119a93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports